import type { ReactNode } from 'react';

import { StatCard, StatGrid } from '../../../chrome/page';
import { Skeleton } from '../../../ui/skeleton';
import { OverviewBody } from './layout';
import { ov } from './messages';
import { OverviewCard } from './OverviewCard';

const FIGURES = ['figure.reach', 'figure.posts', 'figure.accounts', 'figure.sentiment'] as const;

function Block(props: { className: string }): ReactNode {
  return <Skeleton className={props.className} />;
}

export function OverviewSkeleton(): ReactNode {
  return (
    <div className="flex flex-col gap-4">
      <span role="status" className="sr-only">
        {ov('loading')}
      </span>
      <div aria-hidden className="flex flex-col gap-4">
        <StatGrid>
          {FIGURES.map((figure) => (
            <StatCard key={figure} label={ov(figure)} value={<Block className="h-8 w-24" />} />
          ))}
        </StatGrid>
        <OverviewBody
          main={
            <>
              <OverviewCard title={ov('movement.title')}>
                <Block className="h-44 w-full" />
              </OverviewCard>
              <OverviewCard title={ov('groups.title')}>
                <Block className="h-40 w-full" />
              </OverviewCard>
            </>
          }
          side={
            <OverviewCard title={ov('territory.title')}>
              <Block className="h-32 w-full" />
            </OverviewCard>
          }
        />
      </div>
    </div>
  );
}
